import React from 'react';
import Grid from '../../../components/Grid';
import { useSelector } from 'react-redux';
import { SelectShowCloudAgents, selectCloudAgents, selectUserAgents } from 'store/Agents/selectors';
import TableContent from '../../../components/TableContent';
import { RUN_STATUS_LOG } from '../../Tabs/constants';
import { selectAllowedByFeature, selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_CLOUD_AGENTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const RecordsRepresentation = ({ showGridView, selectedTab }) => {
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const userAgents = useSelector(selectUserAgents);
  const cloudAgents = useSelector(selectCloudAgents);
  const isCloudAllowedByFeature = useSelector((state) => selectAllowedByFeature(state, FEATURE_CLOUD_AGENTS, PERMISSION_TYPES.READ));
  const isCloudAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_CLOUD_AGENTS, PERMISSION_TYPES.READ));
  const isCloudAllowed = isCloudAllowedByFeature && isCloudAllowedByRole;

  if (showGridView && selectedTab !== RUN_STATUS_LOG) return <Grid agents={ showCloudAgents ? cloudAgents : userAgents } isCloudAllowed={ isCloudAllowed } />;
  return <TableContent selectedTab={ selectedTab } isCloudAllowed={ isCloudAllowed } />;
};

export default RecordsRepresentation;
